/**
 * 目前仅询价页使用
 */

import { useMount, useSetState } from "ahooks";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { debounce, keys } from "lodash";
import { Input, message, Select } from "antd";
import { useQuery } from "react-query";
import classNames from "classnames";
import { IInquiryKind } from "@Types/inquiry";
import AgreeModal from "@Components/ask/AgreeModal";
import { fetchInquiryRegion, fetchUserProfile } from "@Services/api";
import validator from "email-validator";
import SendVerificationCode from "../SendVerificationCode";
import { ConfirmFillIcon, RoundIcon } from "@t8891/icon";
import RegionItem from "../RegionItem";

import styles from "../../../pages/ask/price.module.less";
import { g4 } from "../../../utils/helper";
import Cookies from "js-cookie";
import { Button } from "@t8891/pc";
import SplitText from "@Components/SplitText";
import qs from "qs";
import { initTracking } from "@Lib/jotai/tracking";
import { useAtom } from "jotai";
import AdRegionItem from "../AdRegionItem";
import {
  AgeItem,
  BuyCarPurchases,
  BuyCarReason,
  EmailItem,
  RenderAnswerDateSelect,
  RenderNameInput,
  SexItem,
} from "./common";
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: #E8E8E8;
    border-radius: 4px;
  }
`;

export interface FormParams {
  mobile: string;
  code: string;
  name: string;
  buyCarTime?: string;
  agencyAgreement: 0 | 1;
  agreeCarResource?: 0 | 1;
  regionName: string;
  email?: string;
  codeVerify: 0 | 1;
  crossRegion?: number;
  region?: string | number;
  age?: number;
  section?: number;
  dealer?: number;
  purchases?: number;
  reason?: number;
  matchStatus: 0 | 1;
  sex?: 0 | 1;
  contactTime?: string;
  inquiryStory?: number;
  inquiryStoryRemark?: string;
  toggleSelect?: any;
  isSeeCar?: number;
  sectionName: string;
  dealerName: string;
  fristTimeReason?: boolean;
  fristTimePurchases?: boolean;
  fristTimeSex?: boolean;
}

let timeout: any;

interface InquiryFormProps {
  toggleSelect?: any;
  inquiryData: any;
  source: string;
  kindData: IInquiryKind;
  onSubmit: (params) => void;
  firstFilled?: () => void;
  inquiryOptions;
  type?: string;
  kindType?: string;
  abTest?: string;
  isRoster: boolean;
  isHideAnswerDate?: boolean;
}

const InquiryForm: React.FC<InquiryFormProps> = ({
  inquiryData,
  toggleSelect,
  kindData,
  isRoster,
  inquiryOptions,
  onSubmit,
  source,
  type,
  kindType,
  abTest,
}) => {
  const [tracking] = useAtom(initTracking);

  const params = qs.parse(location.search, { ignoreQueryPrefix: true }) as any;

  const [query, setQuery] = useSetState({
    consentVisible: false,
    toggle1: false,
    toggle2: false,
    toggle3: false,
    protectStatus: false,
    nameTips: "",
    emailTips: "",
    visibleAgree: false,
    mobileTips: "",
    codeTips: "",
  });
  const {
    toggle1,
    toggle2,
    toggle3,
    visibleAgree,
    consentVisible,
    mobileTips,
    nameTips,
    codeTips,
    emailTips,
    protectStatus,
  } = query;

  const codeRef = useRef(null);

  const [formData, setFormData] = useSetState<FormParams>({
    mobile: "",
    code: "",
    name: "",
    buyCarTime: undefined,
    agencyAgreement: 0,
    agreeCarResource: 0,
    crossRegion: undefined,
    region: undefined,
    codeVerify: 1,
    matchStatus: 1,
    contactTime: undefined,
    inquiryStory: undefined,
    inquiryStoryRemark: "",
    isSeeCar: undefined,
    section: undefined,
    email: undefined,
    sex: undefined,
    dealer: undefined,
    age: undefined,
    purchases: undefined,
    reason: undefined,
    regionName: "請選擇地區",
    sectionName: "請選擇區域",
    dealerName: "請選擇展示中心",
    fristTimeReason: true,
    fristTimePurchases: true,
    fristTimeSex: true,
    fristTimeAge: true,
  });

  useEffect(() => {
    if (!!kindData && !!inquiryData?.mobile) {
      setFormData({
        mobile: inquiryData?.mobile,
        name: inquiryData?.name,
      });
    }
  }, [isRoster, kindData]);

  const { mobile, code, name, agencyAgreement, agreeCarResource, codeVerify, email, dealer, region } = formData || {};

  const initData = {};
  const { data: regions = initData } = useQuery<any>(
    [`fetchInquiryRegion`, kindData?.brandId],
    async () => {
      const res = await fetchInquiryRegion({ b: kindData?.brandId });

      if (res?.status === 12000) {
        if ((inquiryData as any)?.region) {
          res.data.selectedIndex = res.data.regions?.findIndex((item) => item.id === (inquiryData as any)?.region);
        }
        const temp = res.data?.regions;
        const selectIndex = res.data.selectedIndex;

        let name = temp[selectIndex || 0]?.name;
        if (!!params.regionId) {
          name = temp.find((item) => `${item.id}` === params.regionId)?.name;
        }

        if (selectIndex > -1) {
          setFormData({ region: params.regionId || temp[selectIndex || 0].id, regionName: name });
        } else {
          setFormData({ region: params.regionId || undefined, regionName: name || "請選擇地區" });
        }

        return res.data;
      }
      return initData;
    },
    { enabled: !!kindData?.brandId },
  );

  useMount(async () => {
    if (keys(inquiryData).length !== 0) {
      setQuery({ protectStatus: true });
    }

    /** 填充手机号 */
    const res = await fetchUserProfile({});
    if (res.status === "12000" && res?.data?.data?.mMobile) {
      setFormData({ codeVerify: 0, mobile: res?.data?.data?.mMobile });
    }
  });

  /** 值更新回调 */
  const onValChange = (values, obName: string, isMsg: boolean) => {
    clearTimeout(timeout);

    let tip = "";

    if (obName === "region" && !values) {
      tip = "請選擇地區";
    }

    if (obName === "code" && codeVerify === 1 && (values === "" || values.length != 6)) {
      tip = values === "" ? "驗證碼不能為空！" : "驗證碼長度不正確";
    }

    if (obName === "mobile" && (values === "" || !/^09\d{8}$/.test(values))) {
      tip = !!values ? "請輸入正確的手機號" : "請輸入手機號";
    }
    // 匹配只包含中文和英文的正则表达式
    const regex = /^[\u4E00-\u9FA5A-Za-z]+$/;
    if (obName === "name" && !regex.test(values)) {
      tip = "暱稱只能是漢字或者英文";
    }

    if (obName === "name" && values === "") {
      tip = "請輸入稱呼";
    }

    if (tip !== "" && isMsg) {
      timeout = setTimeout(() => {
        message.error(tip);
      }, 800);
    }
    setQuery({ [obName + "Tips"]: tip } as any);

    setFormData({ [obName]: obName !== "mobile" ? values : values.replace(/[^\d]/g, "") } as any);

    // if (codeVerify === 0 && obName === "mobile") {
    //   setFormData({ codeVerify: 1 });
    // }

    return tip;
  };

  const submit = () => {
    let tip =
      onValChange(region, "region", true) ||
      onValChange(dealer, "dealer", true) ||
      onValChange(name, "name", true) ||
      onValChange(mobile, "mobile", true) ||
      onValChange(code, "code", true) ||
      onValChange(email, "email", true);

    if (tip !== "") return;

    if (!!formData.region && agencyAgreement === 0) {
      setQuery({ consentVisible: true });
      return;
    }
    onSubmit?.(formData);
  };

  /** 手機號 */
  const renderMobileInput = () => {
    return (
      <section className='w-full relative mb-24 flex items-center'>
        {mobileTips !== "" && (
          <span className='absolute top-36 left-88 text-[#ff0000] leading-14 h-14'>{mobileTips}</span>
        )}
        <div className={`w-86 relative flex`}>
          <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
          <SplitText label='手機號' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
        </div>
        <div className='flex-1 text-[#333] inline-block'>
          <Input
            onChange={(e) => {
              onValChange(e.target.value, "mobile", false);
              setFormData({ codeVerify: 1 });
            }}
            type='text'
            onClick={() => {
              setQuery({ protectStatus: false });
              // setProtectStatus(false);
            }}
            onBlur={(e) => {
              onValChange(e.target.value, "mobile", true);
              if (mobile.length === 10) {
                setQuery({ protectStatus: true });
              }
              tracking.trackEvent({
                name: "element_clicked",
                params: {
                  expand: e.target.value,
                  page_sub_business: "新車線索",
                  page_business: "新車",
                  trigger_id: "2026",
                  page_id: "108",
                  trigger_name: "手機號填寫",
                  next_spm: "3.108.272.710",
                  page: "詢價提交頁-資料填寫",
                  channel: "新車",
                  element_id: "手機號填寫",
                  element: "表單項",
                  module: "一鍵詢價按鈕",
                  tracker_method: "config",
                },
              });
            }}
            style={{ borderRadius: "4px", borderColor: "#E8E8E8" }}
            maxLength={10}
            // placeholder={"通話免費，業代看不到您的手機號"}
            placeholder={isRoster ? "請填寫您的手機號碼" : "通話免費，業代看不到您的手機號"}
            value={!protectStatus ? mobile : mobile ? mobile.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2") : ""}
          />
          <i
            className={classNames(styles["protect-icon"], {
              [styles["press"]]: protectStatus,
            })}
          />
        </div>
      </section>
    );
  };

  /** 驗證碼 */
  const renderCodeInput = () => {
    if (codeVerify !== 1) {
      return <></>;
    }
    return (
      <section id='renderCodeInput' className='w-full relative mb-24 flex items-center'>
        {codeTips !== "" && <span className='absolute top-38 left-88 text-[#ff0000] leading-14 h-14'>{codeTips}</span>}
        <div className={`w-86 relative flex`}>
          <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
          <SplitText label='驗證碼' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
        </div>
        <div className='flex-1 relative'>
          <div className='flex gap-10 w-[354px] justify-between'>
            <Input
              style={{ borderRadius: "4px", width: "250px", borderColor: "#E8E8E8" }}
              onChange={(e) => onValChange(e.target.value, "code", false)}
              placeholder='請輸入驗證碼'
              onBlur={(e) => {
                onValChange(e.target.value, "code", true);
                tracking.trackEvent({
                  name: "element_clicked",
                  params: {
                    expand: e.target.value,
                    page_sub_business: "新車線索",
                    page_business: "新車",
                    trigger_id: "2028",
                    page_id: "108",
                    trigger_name: "驗證碼填寫",
                    next_spm: "3.108.272.711",
                    page: "詢價提交頁-資料填寫",
                    channel: "新車",
                    element_id: "驗證碼填寫",
                    element: "表單項",
                    module: "一鍵詢價按鈕",
                    tracker_method: "config",
                  },
                });
              }}
              type='tel'
              maxLength={6}
              value={code}
              ref={codeRef}
            />

            <SendVerificationCode
              style={{ marginLeft: "20px", float: "right", position: "absolute", right: 0, bottom: 0 }}
              account={mobile}
              onCallBack={() => {
                g4("verification_code_got", {
                  page_name: "一鍵詢價頁",
                  page_module: "手機驗證",
                  element: "發送驗證碼",
                  business: "銷售線索",
                  source_type: Cookies.get("globalSource") || source,
                });
              }}
              type='7'
            />
          </div>
        </div>
      </section>
    );
  };

  const btnContent = {
    installment: "獲取分期方案",
    currentCar: "我要查詢",
    insurance: "獲取保險方案",
    tradeIn: "獲取換新報價",
    bookDrive: "我要預約",
    subscribe: "我要預約",
    checkPrice: "我要查詢",
  };

  /** 提交按鈕 */
  const renderSubmitBtn = () => {
    if (type === "roster" || kindType === "checkPrice") {
      return (
        <div className='w-442'>
          <Button
            block
            round
            size='large'
            type='danger'
            style={{ "--color": "#FF4433" }}
            onClick={debounce(() => submit(), 200)}
          >
            {!!kindType ? btnContent[kindType] : "我要詢價"}
          </Button>
        </div>
      );
    }
    return (
      <div className='w-442'>
        <Button
          block
          round
          size='large'
          type='danger'
          style={{ "--color": "#FF4433" }}
          onClick={debounce(() => submit(), 200)}
        >
          {kindType && btnContent[kindType] ? btnContent[kindType] : "我要詢價"}
          {!!kindData?.brandId && !!kindData?.inquiryMessage && (
            <div
              className='text-12 h-16'
              dangerouslySetInnerHTML={{
                __html: kindData?.inquiryMessage,
              }}
            />
          )}
        </Button>
      </div>
    );
  };

  /** 協議 */
  const renderAgreement = () => {
    if (type === "roster") {
      return (
        <div className='text-[#999] text-12 w-460 mt-20 my-auto relative flex'>
          <div className='mr-6 inline-block'>
            {agencyAgreement === 1 ? (
              <ConfirmFillIcon
                size={14}
                fill='#3264FF'
                onClick={() => {
                  setFormData({ agencyAgreement: Number(!agencyAgreement) as 0 | 1 });
                }}
              />
            ) : (
              <RoundIcon
                size={14}
                onClick={() => {
                  setFormData({ agencyAgreement: Number(!agencyAgreement) as 0 | 1 });
                }}
              />
            )}
          </div>
          <div className='flex-1  leading-[19px]'>
            我已仔細閱讀並同意
            <a href={"https://www.8891.com.tw/help-sev.html"} className='text-[#999] underline' target='_blank'>
              《服務條款》
            </a>
            、
            <a href={"https://www.8891.com.tw/help-article-426.html"} className='text-[#999] underline' target='_blank'>
              《用戶須知》
            </a>
            、
            <a href={"https://www.8891.com.tw/help-laimer.html"} className='text-[#999] underline' target='_blank'>
              《免責聲明》
            </a>
            、
            <a href={"https://www.8891.com.tw/help-pris.html"} className='text-[#999] underline' target='_blank'>
              《隱私權聲明》
            </a>
            、
            <a href={`https://www.8891.com.tw/help-article-442.html`} className='text-[#999] underline' target='_blank'>
              《一鍵詢價服務說明》
            </a>
            等所載內容；本功能由數字科技與數字廣告共同舉辦，點擊代表您同意將個人資料傳送給您所詢價廠牌對應經銷商等相關廠商。
          </div>
        </div>
      );
    }
    return (
      <div className='text-[#999] text-12 w-460 mt-20 my-auto relative flex'>
        <div className='mr-6 inline-block'>
          {agencyAgreement === 1 ? (
            <ConfirmFillIcon
              size={14}
              fill='#3264FF'
              onClick={() => {
                setFormData({ agencyAgreement: Number(!agencyAgreement) as 0 | 1 });
              }}
            />
          ) : (
            <RoundIcon
              size={14}
              onClick={() => {
                setFormData({ agencyAgreement: Number(!agencyAgreement) as 0 | 1 });
              }}
            />
          )}
        </div>
        <div className='flex-1  leading-[19px]'>
          我已仔細閱讀並同意
          <a className='text-[#999] underline' href={"https://www.8891.com.tw/help-sev.html"} target='_blank'>
            《服務條款》
          </a>
          、
          <a className='text-[#999] underline' href={"https://www.8891.com.tw/help-article-426.html"} target='_blank'>
            《用戶須知》
          </a>
          、
          <a className='text-[#999] underline' href={"https://www.8891.com.tw/help-laimer.html"} target='_blank'>
            《免責聲明》
          </a>
          、
          <a className='text-[#999] underline' href={"https://www.8891.com.tw/help-pris.html"} target='_blank'>
            《隱私權聲明》
          </a>
          、
          <a className='text-[#999] underline' href={`https://www.8891.com.tw/help-article-442.html`} target='_blank'>
            《一鍵詢價服務說明》
          </a>
          等所載內容；本功能由數字科技與數字廣告共同舉辦，點擊代表您同意將個人資料傳送給您所詢價廠牌對應經銷商等相關廠商。
        </div>
      </div>
    );
  };

  return (
    <section id='inquiry-form'>
      <GlobalStyles />
      <AgreeModal
        visibleAgree={consentVisible}
        onClose={() => {
          setQuery({ consentVisible: false });
        }}
        onClick={() => {
          onSubmit?.({ ...formData, agencyAgreement: 1 });
          setFormData({ agencyAgreement: 1 });
          setQuery({ consentVisible: false });
        }}
      />
      {/* <SecondConfirmation
        kindData={kindData}
        visible={consentVisible}
        setQuery={setQuery}
        onClick={() => {
          setFormData({ agencyAgreement: 1 });
          onSubmit?.({ ...formData, agencyAgreement: 1 });
          setQuery({ consentVisible: false });
        }}
      /> */}
      {/* 名单广告地区筛选 */}
      {/* {!!kindData && kindData?.rosterConfig?.reason && ( */}
      {!!kindData && (
        <>
          {!!kindData?.rosterConfig?.dealer && Object.entries(kindData?.rosterConfig?.dealer)?.length > 0 && (
            <AdRegionItem
              dataSource={regions}
              formData={formData}
              kindData={kindData}
              toggleSelect={toggleSelect}
              onSelectIndex={(index, name, type) => {
                if (type === "region") {
                  setFormData({
                    region: regions.regions[index].id,
                    regionName: name,
                    section: undefined,
                    sectionName: "請選擇區域",
                    dealer: undefined,
                    dealerName: "請選擇展示中心",
                  });
                }
                if (type === "section") {
                  setFormData({
                    section: index,
                    sectionName: name,
                    dealer: undefined,
                    dealerName: "請選擇展示中心",
                  });
                }
                if (type === "dealer") {
                  setFormData({
                    dealer: index,
                    dealerName: name,
                  });
                }
              }}
            />
          )}
          {(!kindData?.rosterConfig?.dealer || Object.entries(kindData?.rosterConfig?.dealer).length === 0) && (
            <RegionItem
              dataSource={regions}
              formData={formData}
              toggleSelect={toggleSelect}
              onSelectIndex={(index, name) => {
                setFormData({
                  region: regions.regions[index].id,
                  regionName: regions.regions[index].name,
                });
              }}
            />
          )}
          {/* 填写称呼 */}
          <RenderNameInput
            nameTips={nameTips}
            setFormData={setFormData}
            onValChange={onValChange}
            placeholder={"如：陳先生"}
            name={name}
            formData={formData}
            rightContent={
              isRoster &&
              kindData?.rosterConfig?.sex !== undefined && (
                <SexItem
                  setFormData={setFormData}
                  formData={formData}
                  setQuery={setQuery}
                  toggle2={toggle2}
                  // fristTimeSex={fristTimeSex}
                />
              )
            }
          />

          {renderMobileInput()}

          {renderCodeInput()}

          {/* 填写Email */}
          {!!kindData?.rosterConfig?.email && (
            <EmailItem tips={emailTips} setFormData={setFormData} onValChange={onValChange} formData={formData} />
          )}

          {/* 请选择年龄 */}
          {kindData?.rosterConfig?.age?.length > 0 && (
            <AgeItem
              ageData={kindData?.rosterConfig?.age}
              setFormData={setFormData}
              formData={formData}
              setQuery={setQuery}
              toggle2={toggle2}
            />
          )}

          {/* 接听时间 */}
          {/* {!isHideAnswerDate && (
        <RenderAnswerDateSelect
          inquiryOptions={inquiryOptions}
          setFormData={setFormData}
          formData={formData}
          setQuery={setQuery}
          toggle1={toggle1}
        />
      )} */}
          {/* 購車使用 */}
          {!!kindData.rosterConfig?.reason && (
            <BuyCarReason
              inquiryOptions={inquiryOptions}
              setFormData={setFormData}
              formData={formData}
              setQuery={setQuery}
              toggle1={toggle2}
            />
          )}
          {/* 購車類型 */}
          {!!kindData.rosterConfig?.purchases && (
            <BuyCarPurchases
              inquiryOptions={inquiryOptions}
              setFormData={setFormData}
              formData={formData}
              setQuery={setQuery}
              toggle1={toggle3}
            />
          )}
        </>
      )}
      {kindType === "tradeIn" && (
        <div
          className='w-440 h-26 text-14 text-[#333] bg-[#F7FAFF] rounded-4 my-20 flex justify-center items-center'
          style={{ border: "1px dashed #adcaff" }}
        >
          <div className='flex justify-center gap-8 items-center cursor-pointer relative top-1'>
            {!agreeCarResource ? (
              <img
                className='w-14 h-14'
                onClick={() => {
                  setFormData({
                    agreeCarResource: 1,
                  });
                }}
                src='https://photo.8891.com.tw/2024/08/23/1724385351744372.png'
              />
            ) : (
              <img
                className='w-14 h-14'
                onClick={() => {
                  setFormData({
                    agreeCarResource: 0,
                  });
                }}
                src='https://photo.8891.com.tw/2024/08/23/1724385351753215.png'
              />
            )}
            同意舊車高價賣給車商，最快1小時內聯絡您！
          </div>
        </div>
      )}

      <span
        id={kindType === "tradeIn" ? "AskPriceInquiryTradeInBtn" : "AskPriceInquiryBtn"}
        data-agree={!!agreeCarResource ? "是" : "否"}
      >
        {renderSubmitBtn()}
      </span>

      {renderAgreement()}
    </section>
  );
};

export default InquiryForm;
